<template>
  <div class="slide-up-button-w" @click="$emit('click', $event)">
    <div v-if="type === 'normal'" class="normal">
      <i class="material-icons" style="margin-right: 8px">{{icon}}</i>
      <slot></slot>
    </div>
    <div v-if="type === 'danger'" class="danger">
      <i class="material-icons" style="margin-right: 8px">{{icon}}</i>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SlideUpButton',
  props: {
    type: String,
    icon: String
  },
  methods: {
    renameFolder: function () {
      // console.log('RENAME FOLDER')
    }
  }
}
</script>

<style scoped>
.slide-up-button-w {
  box-sizing: border-box;
  font-weight: bold;
  line-height: 36px;
  padding: 4px 20px;
  position: relative;
  cursor: pointer;
}
.normal {
  color: #333;
  display: flex;
  align-items: center;
}
.danger {
  color: salmon;
  display: flex;
  align-items: center;
}
</style>
